import { render, staticRenderFns } from "./FormUpload.vue?vue&type=template&id=608e30ca&scoped=true&"
import script from "./FormUpload.vue?vue&type=script&lang=js&"
export * from "./FormUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608e30ca",
  null
  
)

export default component.exports